import React from 'react'
import clsx from 'clsx'
import useStyles from './styles'
import CustomLink, { Link } from 'components/common/CustomLink/CustomLink'

export type ButtonType =
    | 'primary'
    | 'secondary'
    | 'outline'
    | 'default'
    | 'tertiary'
    | 'facebook'
    | 'white'
    | 'disabled'

interface CallToActionButtonProps {
    id?: string
    testId?: string
    text: string
    content?: React.ReactNode
    link?: Link
    className?: string
    contentClassName?: string
    sideContent?: React.ReactNode
    disabled?: boolean
    onClick?: () => void
    type?: ButtonType
    size?: 'normal' | 'large'
    display: 'fixed' | 'block' | 'inline'
}

const CallToActionButton: React.FC<CallToActionButtonProps> = ({
    testId = 'cta-button',
    link,
    text,
    content,
    className,
    contentClassName,
    type,
    size,
    sideContent,
    display,
    disabled,
    onClick,
    ...props
}) => {
    const classes = useStyles()
    const mainContent = content || text
    return (
        <div className={clsx(classes.container, classes[size || 'normal'], className)}>
            <div
                className={clsx(
                    contentClassName,
                    classes[(disabled ? 'disabled' : type) || 'default'],
                    classes[display || 'fixed'],
                )}
                onClick={disabled ? () => {} : onClick}
                data-testid={testId}
                {...props}
            >
                {link && !disabled ? (
                    <CustomLink link={link} content={mainContent} />
                ) : (
                    <span className="text">{mainContent}</span>
                )}
            </div>
            {sideContent && <div className={classes.sideContent}>{sideContent}</div>}
        </div>
    )
}

export default React.memo(CallToActionButton)
